import { listingReducer } from "../reducers/utils/listingReducer";
import { getBannerList } from "../../services/BannerConfig";

const { reducer, actions, types } = listingReducer({
  name: `bannerConfig`,
  getApi: getBannerList,
});
const bannerConfig = reducer;
export { bannerConfig, actions, types };
